//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<template>
  <div class='content-wrapper'>
    <div style="font-family:'Roboto Thin'; font-size:16px; padding-bottom:3px; padding-right: 5px; margin-bottom:15px; border-bottom: solid 1px #ddd; float:left;">
      Редактирование задачи
    </div>
    <div v-if="editingTask!= null">
      <div style="width:100%; font-family:'Roboto Thin'; font-size:16px; padding-bottom:5px; float:left;">
        Задача:
        <Input v-model="editingTask.name" size="large" style="width:585px;" ref="taskname" v-on:on-blur="nameOnBlur()"/>
      </div>

      <div style="padding: 30px 0px 0px 0px; width:100%; float:left">
        <Button type="warning" style="border-radius:3px; margin-bottom:10px;" @click="saveOnClick">Сохранить</Button>
        <Button type="ghost" style="border-radius:3px; margin-bottom:10px;" @click="cancelOnClick">Отменить</Button>
        <Button type="text" style="border-radius:3px; margin-bottom:10px;" @click="archiveOnClick" disabled>Архивировать</Button>
        <Button type="text" style="border-radius:3px; margin-bottom:10px;" @click="deleteOnClick">Удалить</Button>
      </div>
    </div>

    <div v-else style="width:100%; float:left">
      <div style="width:100%; padding-top:10px; padding-bottom: 20px; float:left">* нет задачи для редактирования </div>
      <router-link to="/tasks">Вернуться к списку задач</router-link>
    </div>
  </div>
</template>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<script>
import { mapGetters, mapMutations } from 'vuex'

import serverErrorHandling from '@/technical/serverErrorHandling'

export default {
  data () {
    return {
      editingTask: null
    }
  },
  watch: {
    // сработает в тех случаях когда панель уже создавалась и открылась, а commonData.taskBoardForChangeSettings вовне заново изменен
    // в остальных случаях работаем через created
    'commonData.taskForEdit': function (newVal, oldVal) {
      if (this.commonData.taskForEdit != null) {
        this.editingTask = Object.assign({}, this.commonData.taskForEdit.val)
        if (this.editingTask.name === '[Без названия]') this.editingTask.name = ''
        this.$nextTick(() => this.$refs.taskname.$el.children[1].focus()) // устанавливает фокус на input name
      } else {
        this.editingTask = null
      }
    }
  },
  created: function () {
    // это случай когда панель открывается первый раз (а значит создается) а commonData.taskBoardForChangeSettings уже установлен и watch выше уже не сработает
    if (this.commonData.taskForEdit != null) {
      this.editingTask = Object.assign({}, this.commonData.taskForEdit.val)
      if (this.editingTask.name === '[Без названия]') this.editingTask.name = ''
      this.$nextTick(() => this.$refs.taskname.$el.children[1].focus()) // устанавливает фокус на input name
    } else {
      this.editingTask = null
    }
  },
  computed: {
    ...mapGetters([
      'commonData'
    ])
  },
  methods: {
    ...mapMutations([
      'commonDataTaskForEditSet',
      'commonDataTaskForEditValSet',
      'commonDataTaskValSet',
      'commonDataTasksRemove'
    ]),
    nameOnBlur () {
      if (this.editingTask.name === '') this.editingTask.name = '[Без названия]'
    },
    saveOnClick () {
      let thisRef = this
      this.commonDataTaskForEditValSet(this.editingTask)
      this.commonData.taskForEdit.save()
      .then(function (response) {
        thisRef.commonDataTaskValSet(response.data)
        thisRef.commonDataTaskForEditSet(null)
        thisRef.$router.push('/tasks')
      })
      .catch((error) => serverErrorHandling(error, thisRef))
    },
    cancelOnClick () {
      this.commonDataTaskForEditSet(null)
      this.$router.push('/tasks')
    },
    deleteOnClick () {
      let thisRef = this
      this.commonData.taskForEdit.delete()
      .then(function (response) {
        thisRef.commonDataTasksRemove(thisRef.editingTask.id)
        thisRef.$router.push('/tasks')
      })
      .catch((error) => serverErrorHandling(error, thisRef))
    },
    archiveOnClick () {
    }
  }
}
</script>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<style scoped>
.content-wrapper{
  margin: 0px 0px 0px 0px; /* margin: 25px 20px 50px 20px; */
  padding: 0px;
  background: #fff;
  /*height: 100%;*/ /* если цвет отличный от стандартной серой подложики для content или убираем серые margins, то чтобы серый прикрыть надо height=100% */
  /*font-family: "Roboto Light", sans-serif;*/
  /*font-size: 13px;*/
}
</style>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// TaskEdit.vue?c7912456